import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import PaymentSystemFormHandler from '../../containers/formHandlers/center/paymentSystem/paymentSystem/PaymentSystemFormHandler';
import AddressFormHandler from '../../containers/formHandlers/center/paymentSystem/address/AddressFormHandler';
import CorrespondanceFormHandler from '../../containers/formHandlers/center/paymentSystem/correspondance/CorrespondanceFormHandler';
import ParametersFormHandler from '../../containers/formHandlers/center/paymentSystem/parameters/ParametersFormHandler';

const PaymentSystem = () => {
  return (
    <CC.Tabs>
      <div style={{overflow: 'auto'}}>
        <CC.TabList>
          <CC.Tab minWidth={'fit-content'}>Systeme Paiement</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Addresse</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Correspondance</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Parametres</CC.Tab>
        </CC.TabList>
      </div>

      <CC.TabPanels>

        <CC.TabPanel>
          <PaymentSystemFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <AddressFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <CorrespondanceFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <ParametersFormHandler />
        </CC.TabPanel>

      </CC.TabPanels>
    </CC.Tabs>
  )
}

export default PaymentSystem;